
define('ldsh!modules/role/create/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Role</h1>\n<div class="form form-horizontal" role="form">\n  \n\n  <div class="form-group">\n    <label for="Name">Name</label>\n    <input type="text" class="form-control" id="name" name="name" placeholder="Name">\n  </div>\n\n  \n\n  <div class="form-group">\n    <label for="Label">Label</label>\n    <input type="text" class="form-control" id="label" name="label" placeholder="Label">\n  </div>\n\n\n\n\n\n\n\n\n\n\n\n\n  <button type="button" class="btn btn-default submitForm">Submit</button>\n</div>';

}
return __p
};});

